import React, {Component} from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import Config, {prodConfig} from '../config';
import {
    Page,
    Preload,
    WKError,
} from '../components'
import '../styles/recorddetaillist/FavouriteRecordPage.css'
import {TimeStream, isLZWKAPP, isLZWKAPPIpad, judgeAPPVersion, getAccessToken, isFromCPSLiveroom, shouldLinkToAPP} from '../utils';
import { toLecture, toChannel } from '../utils/connectApp'
import {
    Flex,
    FlexItem,
    LoadMore,
    Toast
} from 'react-weui';
import { WKVisible } from '../components/wk'
import {NoneItem} from '../components/details'
import onRecordImg from '../images/no-record-data.png'
import { Dialog } from '../components/dialog'

import hand from '../images/hand.png'
import { isChannelCPS } from '../utils/cps';
import { isInteractiveChannel, isInteractiveLecture } from '../utils/hardcode'
import { AppInteractiveLectureTip } from '../components/appInteractiveLectureTip'
import { isInSaasLiveroom, getSaasLiveroomId } from '@weike/services'

class FavouriteRecordPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
           favourites: [],
           initialized: false,
           hasMore: false,
           nextOffset: '',
           loading: false,
           dialogConfig: {},
           isDialogShow: false,
           toastTetx: '',
           showLoading: false,
           hasLiveroom: false,
           hasShowLectureButton: false
        }
        this.handleLoadMoreData  = this.handleLoadMoreData.bind(this)
        this.handleRefresh = this.handleRefresh.bind(this)
    }

   handleLoadMoreData(){   
        this.setState({loading: true})
        axios.get(`/api/favourite/list`, {params: {offset: this.state.nextOffset}}).then((response) => {
            const {favourites, has_more, next_offset} = response.data.data
            favourites.map(item => item.isFav = true)
            if (response.data.code === 0) {
                this.setState({
                   favourites: [...this.state.favourites , ...favourites],
                   initialized: true,
                   hasMore: has_more,
                   nextOffset: next_offset,
                   loading: false,

                });
                if(favourites.length <= 0){
                    let href = isInSaasLiveroom() ? `/liveroom2/${getSaasLiveroomId()}` : '/';
                    if (shouldLinkToAPP()){
                        href = 'lizhiweike://home';
                    }
                    this.props.dispatch({
                        type: 'ERROR_SHOW',
                        payload: {
                            tips: '收藏夹空空如也~',
                            img: onRecordImg,
                            href: href,
                            btn: (isLZWKAPP() || isLZWKAPPIpad()) ? '' : '回首页看看'
                        }
                    });
                }
            }
        });
    }

    handleDialog(action, type, id) {
        if(action) {
            this.setState({
                isDialogShow: true,
                dialogConfig: {
                    title: `是否取消收藏该${type === 'lecture' ? '课程' : type === 'channel' ? '专栏': '训练营'}`,
                    text: ['继续收藏', '取消收藏'],
                    onCancel: () => {
                      this.setState({isDialogShow: false})
                    },
                    onSubmit: () => {
                       this.handleFavourte(action, type, id)
                    }
                }
            })
        }else {
            this.handleFavourte(action, type, id)
        }
    }

    handleFavourte(action, type, id) {
        const data = new FormData()
        data.append('type', type)
        if(type !=='channel') {
            data.append(type === 'lecture' ? 'lecture_id': 'traincamp_id', id)
        }else {
            data.append('channel_id', id)
        }
        
        let host = prodConfig.BASE_URL
        if(window.location.host === 'dbg.weike.fm' || '139.199.89.56' === location.hostname ||'dbg.lizhiweike.com' === location.hostname || 'localhost' === location.hostname) {
           host = 'http://139.199.89.56:8180'
        }
        axios.post(`${host}/api/favourite/${action ? 'delete' : 'add'}?token=${getAccessToken()}`, data).then((response) => {
           if(response.data.code === 0) {
               this.setState({
                   isDialogShow: false,
                   favourites: this.state.favourites.map(item => {
                       if(item.object_id === id) {
                           item.isFav = !action
                       }
                       return item
                   }),
               })
           }else {
              if(this.state.showLoading) return
              this.setState({
                  toastTetx: response.data.msg,
                  showLoading: true
              })
              let loadingTimer = setTimeout(()=> {
                this.setState({
                    toastText: response.data.msg, 
                    showLoading: false
                });
            }, 1000);
           }
        })
    }

    gethasLiveroomStatus = () => {
        axios.get('/api/account/has_liveroom').then(({data: { data: { has_liveroom } } }) => {
            if(has_liveroom) {
                this.setState({
                    hasLiveroom: has_liveroom
                })
            }
        })
    }

    handleRefresh(){
        window.location.reload();
    }

    componentDidMount() {
        document.title = '我的收藏'

        this.handleLoadMoreData()
        
        this.gethasLiveroomStatus()

    }

    onClickItem (item) {
        // const isChannel = item.object_type === 'channel'
        // const isLecture = item.object_type === 'lecture'
        // const id = item.object_id
        // if (isLZWKAPP()) {
        //     // 是专栏并且是互动专栏 或者 是课程并且是互动课程
        //     if ((isChannel && isInteractiveChannel(id)) || (isLecture && isInteractiveLecture(id))) {
        //         this.showInteractiveLectureTip()
        //         return
        //     }
        // }
        if (isLZWKAPP() || isLZWKAPPIpad()) {
            if (item.object_type === 'lecture') {
                return toLecture({ id: item.object_id, lectureMode: item.lecture_mode })
            }
            if (item.object_type === 'channel') {
                return toChannel(item.object_id)
            }
        } else {
            location.assign(`/${item.object_type}/${item.object_id}`)
        }
    }

    renderPopular(num) {
        if (num < 1e4) {
          return num
        } else {
          return `${+(num / 1e4).toFixed(1)}万`
        }
    }

    tabType(type, lecture_type) {
       if(type === 'channel') {
           return 'https://staticqc.lycheer.net/account3/static/media/column.a9db15ad.png'
       }else {
          return {
            video: 'https://img.lycheer.net/material/59358349/5ce60e17e9043a4e66091d0f.png',
            audio: 'https://img.lycheer.net/material/59358349/5ce60e18eff0a52f95ac4642.png'
          }[lecture_type]
       }
    }

    openLectureButton(){
        if(!this.state.hasShowLectureButton){
            window.gio && window.gio("track","myfavorite_teacherbutton_by_eject");
            this.setState({hasShowLectureButton: true})
        }
        return <div className="create-my-class"
            onClick={() => {
                window.gio && window.gio("track","myfavorite_teacherbutton_by_click");
                location.assign('/management/liveroom/first-create')
            }}>
            <p>一键开课</p>
            <img src={hand} alt=""/>
        </div>
    }

    showInteractiveLectureTip () {
        this.appInteractiveLectureTip.show()
    }

    render() {
        const {initialized, favourites, hasMore, loading, hasLiveroom} = this.state
        const {error} = this.props

        if (!initialized) {
            return <Preload />
        } 
        if (error.showError) {
            return (
                <div className="sharecard-slide-page_error">
                    <WKVisible create={!(isLZWKAPP() || isLZWKAPPIpad())}>
                        <div className="favourite-record-page-title"><span onClick={this.handleRefresh}>收藏记录</span></div>
                        {!isChannelCPS() && <div className="favourite-traincamp-button" onClick={() => location.assign(`/account3/favorite`)}>训练营收藏</div>}
                    </WKVisible>
                    { 
                        !isFromCPSLiveroom() && <div className={`details-none-item`}>
                            <div className="item__img">
                                <img src="https://static-1253442168.file.myqcloud.com/xupload/20190430_pic-wnr.png" alt=""/>
                            </div>
                            <div className="item__text">
                                <div className="text__line">暂无收藏的课程</div>
                                <div className="text__line">快去首页发现更多的内容吧</div>
                            </div>
                            <div 
                              className={"weike__ui__primary"} 
                              onClick={() => window.location = error.href}
                            >
                                回首页看看
                            </div>
                        </div>
                    }
                    {/* {isTest && !isLZWKAPP() && !hasLiveroom && !location.href.includes('is_promote_flag') && <div 
                    className="create-my-class"
                    onClick={() => location.assign('/liveroom/first-create')}>
                    <p>一键开课</p>
                    <img src={hand} alt=""/>
                </div>} */}
                </div>
            )
        }
        return (
            <Page className="favourite-record-page ">
                <div className="favourite-record-page-div">
                    <WKVisible create={!(isLZWKAPP() || isLZWKAPPIpad())}>
                        <div className="favourite-record-page-title"><span onClick={this.handleRefresh}>我的收藏</span></div>
                        {!isChannelCPS() && <div className="favourite-traincamp-button" onClick={() => location.assign(`/account3/favorite`)}>训练营收藏</div>}
                    </WKVisible>
                    <div className="favourite-record-page-list">
                        {
                            favourites.map((item) => {
                                const shouldLinkToAPP = isLZWKAPP() && ((window.systemType === 'ios' && judgeAPPVersion(370)) || (window.systemType === 'android' && judgeAPPVersion(262)));
                                return (
                                    <a
                                       className="favourite-record-page-flex" key={item.id}
                                       onClick={e => this.onClickItem(item)}
                                    >
                                      <div className="favourite-record-page-card">
                                        <Flex>
                                            <FlexItem className='favourite-record-page-item-img'>
                                                <div className="favourite-record-page-img" style={{backgroundImage: `url(${item.cover})`}}>
                                                </div>
                                                <div className="favourite-record-page-hot">
                                                  <div>
                                                    <img src="https://static-1253442168.image.myqcloud.com/picture/10490565_5ddfe21b03842fa68973218ec2737646.jpg"/>
                                                    {this.renderPopular(item.popular)}
                                                  </div>
                                                </div>
                                            </FlexItem>
                                            <FlexItem className="favourite-record-page-item-content">
                                                <ul className="favourite-record-page-ul">
                                                    <li className="favourite-record-page-li-first favourite-record-page-font">
                                                      {
                                                        item.lecture_mode !== 'default' && item.lecture_mode !== 'live_v' &&
                                                        <img 
                                                          className="favourite-record-page-item-channel-type"
                                                          src={this.tabType(item.object_type, item.lecture_mode)} 
                                                        />
                                                      }
                                                      {item.name}
                                                    </li>
                                                    {/* {item.object_type === 'lecture' &&
                                                        <li className="favourite-record-page-li-second favourite-record-page-font">{TimeStream(item.create_timestamp, 'CN_YMD_HM')}</li>
                                                    } */}
                                                    <div className="favourite-record-page-second">
                                                      {item.object_type === 'channel' ?
                                                          <li className="favourite-record-page-li-second favourite-record-page-font">
                                                            已更新{item.lecture_count}期
                                                          </li> : 
                                                          <li></li>
                                                      }
                                                      <div 
                                                        className={
                                                            item.isFav ?
                                                              "favourite-cancel-button" :
                                                              "favourite-cancel-button new-favourite-button"
                                                        }
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            this.handleDialog(item.isFav, item.object_type, item.object_id)
                                                        }}
                                                       >
                                                          { item.isFav ? '取消收藏' : '收藏' }
                                                       </div>
                                                    </div>
                                                </ul>
                                            </FlexItem>
                                        </Flex>
                                      </div>
                                    </a>
                                )
                            })
                        }
                    </div>
                    <div className="footer">
                        {hasMore?
                            loading?
                                <LoadMore loading>正在加载</LoadMore>
                                :
                                <div className="view-more" onClick={this.handleLoadMoreData}>查看更多</div>
                            :
                            null
                            // <LoadMore showLine className="no-more">没有更多内容了</LoadMore>
                        }
                    </div>
                </div>
                <Toast icon="loading" show={this.state.showLoading}>
                  {this.state.toastText}
                </Toast>
                <Dialog 
                  show={this.state.isDialogShow} 
                  dialogConfig={this.state.dialogConfig}
                >
                </Dialog>
                <AppInteractiveLectureTip ref={ ref => this.appInteractiveLectureTip = ref } />

                {!(isLZWKAPP() || isLZWKAPPIpad()) && !hasLiveroom && !location.href.includes('is_promote_flag') && !isInSaasLiveroom() && this.openLectureButton()}
            </Page>
        );
    }
}

export default connect((state) => ({
      error: state.error,
}))(FavouriteRecordPage)



// WEBPACK FOOTER //
// ./src/pages/FavouriteRecordPage.js